import React, { Component } from 'react';
import PropTypes from 'prop-types';
import pure from 'recompose/pure';
import CircularProgress from 'material-ui/CircularProgress';
import { Flex, Box } from 'grid-styled';
import SnackBar from 'material-ui/Snackbar';

import hopeTheme from '../../../styles/themes/hopeTheme';

const errorMessageStyle = {
  zIndex: 4000,
};
const errorMessageBodyStyle = {
  backgroundColor: '#de5949',
  textAlign: 'center',
  zIndex: '4000',
};

const errorContentStyle = {
  marginTop: 6,
  lineHeight: '16px',
};
const noop = () => {};
class RouteLoader extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      errorMessage: false,
    };
  }

  componentDidMount() {
    this.timer = setTimeout(() => this.handleLoader(), 200);
    this.errorMessage = setTimeout(() => this.handleErrorMessage(), 10000);
  }

  componentWillUnmount() {
    clearTimeout(this.timer);
    clearTimeout(this.errorMessage);
  }

  handleLoader = () => {
    this.setState({ isLoading: true });
  };

  handleErrorMessage = () => {
    this.setState({ errorMessage: true });
  };

  render() {
    const containerWidth = window.innerWidth;
    const { isLoading, errorMessage } = this.state;
    const message =
      'There was a disconnect to our server, please refresh your browser';

    if (errorMessage) {
      return (
        <SnackBar
          message={message}
          open={errorMessage}
          style={errorMessageStyle}
          bodyStyle={errorMessageBodyStyle}
          contentStyle={errorContentStyle}
          onRequestClose={noop}
        />
      );
    } else if (containerWidth <= 800) {
      return (
        <Flex align="center" justify="center">
          <Box
            style={{
              margin: '150px auto 100vh auto',
              textAlign: 'center',
            }}
          >
            {isLoading && (
              <CircularProgress
                color={hopeTheme.hopeLightPurple}
                size={80}
                thickness={5}
              />
            )}
          </Box>
        </Flex>
      );
    }
    return (
      <Flex
        align="center"
        justify="space-between"
        style={{
          height: 0,
          paddingBottom: '52.67%',
          position: 'relative',
          textAlign: 'center',
        }}
      >
        <Box
          style={{
            width: '100%',
            margin: '150px auto',
            textAlign: 'center',
            position: 'absolute',
            top: 0,
          }}
        >
          {isLoading && (
            <CircularProgress
              color={hopeTheme.hopeLightPurple}
              size={80}
              thickness={5}
            />
          )}
        </Box>
      </Flex>
    );
  }
}

RouteLoader.contextTypes = {
  router: PropTypes.object.isRequired,
};

export default pure(RouteLoader);
